import React, { useEffect, useState, useContext } from 'react';
import HeroSection from '../components/Home/HeroSection';
import AnalysisCardsSection from '../components/Home/AnalysisCardsSection';
import FeaturesSection from '../components/Home/FeaturesSection';
import HowItWorksSection from '../components/Home/HowItWorksSection';
import SemanticBrandingSection from '../components/Home/SemanticBrandingSection';
import LoginModal from '../components/Authentication/LoginModal';
import RegisterModalNoCode from '../components/Authentication/RegisterModalNoCode';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { semanticBrandingService } from '../services/semanticBranding';
import { ToastContext } from '../App';
const G4GeDiegoIvo = ({
  isLoggedIn,
  onLogin,
  user
}) => {
  const [isLoginModalOpen, setIsLoginModalOpen] = useState(false);
  const [isRegisterModalOpen, setIsRegisterModalOpen] = useState(false);
  const [pendingAnalysis, setPendingAnalysis] = useState(false);
  const [brandData, setBrandData] = useState({
    brand: '',
    url: ''
  });
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const {
    addToast
  } = useContext(ToastContext);
  useEffect(() => {
    // Check if showLogin parameter is present
    if (searchParams.get('showLogin') === 'true' && !isLoggedIn) {
      setIsLoginModalOpen(true);
    }
  }, [searchParams, isLoggedIn]);
  // Check if user is logged in and has a pending analysis
  useEffect(() => {
    if (isLoggedIn && pendingAnalysis && brandData.brand && brandData.url) {
      const createAnalysis = async () => {
        try {
          // Create a new brand document with the pending data
          const response = await semanticBrandingService.createBrandDocument(brandData.brand, brandData.url, true);
          // Navigate to the report page with the document ID and isNewDocument flag
          navigate(`/relatorio/${response.brandDocument.id}`, {
            state: {
              isNewDocument: true
            }
          });
          addToast('success', 'Análise iniciada com sucesso!');
          setPendingAnalysis(false);
        } catch (error) {
          console.error('Failed to create brand document:', error);
          addToast('error', error.response?.data?.message || 'Erro ao criar análise. Tente novamente.');
          setPendingAnalysis(false);
        }
      };
      createAnalysis();
    }
  }, [isLoggedIn, pendingAnalysis, brandData, navigate, addToast]);
  const handleStartAnalysis = (data = null) => {
    if (data) {
      setBrandData(data);
    }
    // If not logged in, store that we have a pending analysis and open register modal
    if (!isLoggedIn) {
      setPendingAnalysis(true);
      setIsRegisterModalOpen(true);
    } else {
      // If logged in, create brand document and navigate to report
      const createAnalysis = async () => {
        try {
          const response = await semanticBrandingService.createBrandDocument(data.brand, data.url, true);
          navigate(`/relatorio/${response.brandDocument.id}`, {
            state: {
              isNewDocument: true
            }
          });
          addToast('success', 'Análise iniciada com sucesso!');
        } catch (error) {
          console.error('Failed to create brand document:', error);
          addToast('error', error.response?.data?.message || 'Erro ao criar análise. Tente novamente.');
        }
      };
      createAnalysis();
    }
  };
  return <>
      <HeroSection isLoggedIn={isLoggedIn} onStartAnalysis={handleStartAnalysis} data-id="element-1293" data-mp="2pbuh7o5xapyf" />
      <AnalysisCardsSection isLoggedIn={isLoggedIn} data-id="element-1294" data-mp="2ki8cqj9wxsdp" />
      <FeaturesSection data-id="element-1295" data-mp="1wtfe2f1wp6fe" />
      <HowItWorksSection data-id="element-1296" data-mp="1wsnpvpan2az5" />
      <SemanticBrandingSection data-id="element-1297" data-mp="1wrvuofkyef9e" />
      <LoginModal isOpen={isLoginModalOpen} onClose={() => setIsLoginModalOpen(false)} onRegisterClick={() => {
      setIsLoginModalOpen(false);
      setIsRegisterModalOpen(true);
    }} pendingAnalysis={pendingAnalysis} data-id="element-1298" data-mp="1rv5cnmpl99lc" />
      <RegisterModalNoCode isOpen={isRegisterModalOpen} onClose={() => setIsRegisterModalOpen(false)} onLoginClick={() => {
      setIsRegisterModalOpen(false);
      setIsLoginModalOpen(true);
    }} pendingAnalysis={pendingAnalysis} data-id="element-1299" data-mp="1007hxhqj3hlx" />
    </>;
};
export default G4GeDiegoIvo;